// extracted by mini-css-extract-plugin
module.exports =  {"popover":"OgyVS2C"};